import axios from '../../../services/axios';
import { getProductsByOperationQuery } from './queries/getProductsByOperationQuery';

const VITE_APP_API_URL = import.meta.env.VITE_APP_API_URL;

export const getProductsByOperation = async ({
  org_id,
  operation_id,
  unit_system,
}: {
  org_id: string;
  operation_id: string;
  unit_system: string;
}) => {
  try {
    const response: any = await axios.post(`${VITE_APP_API_URL}/valet/v2/graphql`, {
      query: getProductsByOperationQuery,
      variables: { org_id, id: operation_id, unit_set: unit_system.toLowerCase() },
    });

    const operation = response.data.data.operations?.[0];
    return operation?.products?.map((product: any) => {
      const measures = operation.product_uses.find(
        (product_use: { resource_ref: string }) => product_use?.resource_ref === product?.id,
      )?.resource_measures;

      const mix_measures = operation.product_uses
        ?.flatMap((productUses: any) => productUses.mix_components)
        .find(
          (mix_components: { resource_ref: string }) =>
            mix_components?.resource_ref === product?.id,
        )?.resource_measures;

      return {
        ...product,
        product_id: product.id,
        measures: measures ?? [],
        mix_measures: mix_measures ?? [],
      };
    });
  } catch (err: any) {
    console.error(err);
    return [];
  }
};
